import {Get} from '../api/server';

async function getCompany () {
    let address = window.location.hostname;
    // console.log(window.location.hostname)

    return await Get('/companies/getByAddress/' + address).then(res => {
        // console.log('yres', res);
        return res;
    }).catch(err => {
        return null;
    });
}

export default getCompany;